const modals = Array.from( document.querySelectorAll( '[data-mount="modal"]' ) );

// Options for the observer (which mutations to observe)
const config = { attributes: true, childList: false, subtree: false };

/**
 * Setup
 */
const setup = () => {
	modals.forEach( ( modal ) => {
		/**
		 * Callback function to execute when mutations are observed
		 */
		const callback = function(  ) {
			const isHidden = 'true' === modal.getAttribute( 'aria-hidden' );

			// Don't replace if we're showing it.
			if ( !isHidden ) {
				return;
			}

			const iframe = modal.querySelector( 'iframe' );
			const clone = iframe.cloneNode();
			iframe.replaceWith( clone );
		};

		// Create an observer instance linked to the callback function
		const observer = new MutationObserver( callback );

		// Start observing the target node for configured mutations
		observer.observe( modal, config );
	} );
};

/**
 * Init
 */
const init = () => {
	if ( !modals.length ) {
		return;
	}

	setup();
};

export default init;
